import React, { useEffect } from "react";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import styles from "./styles";
import withStyles from "@material-ui/core/styles/withStyles";

const EasySelect = (props) => {
  const { propName, classes } = props;
  const setPropMounted = props.connectForm.setPropMounted;

  useEffect(() => {
    setPropMounted(propName, true);
    return () => {
      setPropMounted(propName, false);
    };
  }, [setPropMounted, propName]);
  return (
    <FormControl
      fullWidth
      className={classes.selectFormControl}
      error={props.connectForm.getState(propName) === "Error"}
    >
      <InputLabel htmlFor={propName} className={classes.selectLabel}>
        {props.connectForm.getLabel(propName) + " "}
        {props.connectForm.isRequired(propName) ? (
          <span style={{ color: "red" }}>*</span>
        ) : (
          ""
        )}
      </InputLabel>
      <Select
        MenuProps={{
          className: classes.selectMenu,
        }}
        classes={{
          select: classes.select,
        }}
        value={props.connectForm.getValue(propName)}
        onChange={(event) =>
          props.connectForm.change(event.target.value, propName)
        }
        inputProps={{
          name: propName,
          id: propName,
        }}
      >
        {props.connectForm.getDropdownOptions(propName).map((element, key) => {
          if (Array.isArray(element)) {
            return (
              <MenuItem
                key={key}
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelect,
                }}
                value={element[0]}
              >
                {element[1]}
              </MenuItem>
            );
          } else {
            return (
              <MenuItem
                key={key}
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelect,
                }}
                value={element}
              >
                {element}
              </MenuItem>
            );
          }
        })}
      </Select>
    </FormControl>
  );
};

export default withStyles(styles)(EasySelect);

//
//
